const actionTypes = {
  SET_OVERLAYS: "app/SET_OVERLAYS",
  features: "meta/access/features",
  SET_SELECTED_OVERLAY: "app/SET_SELECTED_OVERLAY",
  SET_SITES: "app/SET_SITES",
  SET_SELECTED_SITE: "app/SET_SELECTED_SITE",
  SET_SELECTED_REMOTE_SITE: "app/SET_SELECTED_REMOTE_SITE",
  SET_CTRL_TIME_FILTER: "app/SET_CTRL_TIME_FILTER",
  SET_SIDE_BAR_TIME_FILTER: "app/SET_SIDE_BAR_TIME_FILTER",
  SET_CUSTOM_TIME: "app/SET_CUSTOM_TIME",
  SET_SIDE_BAR_CUSTOM_TIME: "app/SET_SIDE_BAR_CUSTOM_TIME",
  SET_ACCOUNTS: "app/SET_ACCOUNTS",
  SET_SELECTED_OVERLAY_ROLES: "app/SET_SELECTED_OVERLAY_ROLES",
  SET_REFRESH: "app/SET_REFRESH",
  SET_ALTO_PROPS: "app/SET_ALTO_PROPS",
  SET_SUPPORT_ROLE: "app/SET_SUPPORT_ROLE",
  SET_SSO_LOGOUT: "app/SET_SSO_LOGOUT",
  SET_BREADCRUMBS: "app/SET_BREADCRUMBS",
  setCircuitsLoader: "app/circuits/loader",
  setCircuitsData: "app/circuits/data",
  SET_SITES_TABLE_AVAILABILITY: "app/SET_SITES_TABLE_AVAILABILITY",
  SET_OVERVIEW_ERROR: "app/SET_OVERVIEW_ERROR",
  SET_OVERVIEW_SITE_LOADER: "app/SET_OVERVIEW_SITE_LOADER",
  SET_DEVICE_SITE: "app/SET_DEVICE_SITE",
  SET_DEVICE_OVERVIEW_ERROR: "app/SET_DEVICE_OVERVIEW_ERROR",
  SET_OVERVIEW_DEVICE_LOADER: "app/SET_OVERVIEW_DEVICE_LOADER",
  SET_APPLICATIONDATA_API_STATUS: "app/SET_APPLICATIONDATA_API_STATUS",
  SET_APP_FAMILY_SLA: "app/SET_APP_FAMILY_SLA",
  SET_APP_DATA_WITH_FAMILY_SLA: "app/SET_APP_DATA_WITH_FAMILY_SLA",
  SET_APP_DATA_SELECTED: "app/SET_APP_DATA_SELECTED",
  SET_APP_DATA_SELECTED_LEGEND: "app/SET_APP_DATA_SELECTED_LEGEND",
  SET_POST_LOGIN_NOTIFICATIONS: "app/SET_POST_LOGIN_NOTIFICATIONS",
  SET_PREV_APP_DATA_SELECTED: "app/SET_PREV_APP_DATA_SELECTED",
  SET_APP_DATA_SELECTED_DEFAULT: "app/SET_APP_DATA_SELECTED_DEFAULT",
  SET_TREND_ANALY_FILTER: "app/SET_TREND_ANALY_FILTER",
  SET_SIDEBAR_TABLE_DATA: "app/SET_SIDEBAR_TABLE_DATA",
  SET_ANOMALY_REFRESH: "app/SET_ANOMALY_REFRESH",
  SET_SDWAN_SITE_SUMMARY: "app/SET_SDWAN_SITE_SUMMARY",
  SET_SDWAN_SITE_SUMMARY_ERROR: "app/SET_SDWAN_SITE_SUMMARY_ERROR",
  SET_SDWAN_SITE_SUMMARY_LOADER: "app/SET_SDWAN_SITE_SUMMARY_LOADER",
  SET_TALOS_SITES: "app/SET_TALOS_SITES",
  SET_TALOS_ERROR: "app/SET_TALOS_ERROR",
  SET_TALOS_LOADER: "app/SET_TALOS_LOADER",
  SET_PATH_ANALYTICS_TAB: "app/SET_PATH_ANALYTICS_TAB",
  SET_MENU_STATE: "app/SET_MENU_STATE",
  TIMEFRAME_APP_FLOW: "app/TIMEFRAME_APP_FLOW",
  SET_TOGGLE: "app/SET_TOGGLE",
  SET_APP_FLOW_TABLE_TIME_TEXT: "app/SET_APP_FLOW_TABLE_TIME_TEXT",
  SET_APP_FLOW_QUERY: "app/SET_APP_FLOW_QUERY",
  SET_NOTIFICATION_INSIGHT_LOADER: "app/SET_NOTIFICATION_INSIGHT_LOADER",
  SET_NOTIFICATION_INSIGHT_DATA: "app/SET_NOTIFICATION_INSIGHT_DATA",
  SET_NOTIFICATION_INSIGHT_ERROR: "app/SET_NOTIFICATION_INSIGHT_ERROR",
  SET_OPTIMIZATION_DONUT_CHART_DATA: "app/SET_OPTIMIZATION_DONUT_CHART_DATA",
  SET_OPTIMIZATION_DONUT_CHART_LOADER: "app/SET_OPTIMIZATION_DONUT_CHART_LOADER",
  SET_SELECTED_APPLICATIONS: "app/SET_SELECTED_APPLICATIONS",
  SET_REPORTS_DATA_COUNT: "app/SET_REPORTS_DATA_COUNT",
  SET_APP_QOE_TABLE_LOADER: "app/SET_APP_QOE_TABLE_LOADER",
};

export default actionTypes;
